import { __assign, __rest, __spreadArray } from "tslib";
import { MediaImageStudioMode, } from '@wix/media-image-studio-common';
import { urlParams } from '@wix/media-image-studio-common/utils';
import { MediaImageStudioURL } from '../constants/urls';
import { getCommonConfig } from './commonConfig';
import { isEditorxDomain } from './isEditorxDomain';
export function getURL(url, permanentOptions, showOptions) {
    var baseUrl = url.replace(/\/$/, '');
    var mode = showOptions.mode, restShowOptions = __rest(showOptions, ["mode"]);
    if (mode !== undefined && mode !== MediaImageStudioMode.Default) {
        baseUrl = "".concat(baseUrl, "/").concat(mode);
    }
    var commonConfigData = getCommonConfig();
    var queryParams = __assign(__assign(__assign({}, permanentOptions), restShowOptions), (commonConfigData
        ? { commonConfig: JSON.stringify(commonConfigData) }
        : undefined));
    var consentPolicyParams = '';
    if (window.consentPolicyManager) {
        consentPolicyParams = Object.entries(window.consentPolicyManager._getConsentPolicyHeader())
            .reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            return __spreadArray(__spreadArray([], acc, true), ["".concat(key, "=").concat(value)], false);
        }, [])
            .join('&');
    }
    var queryString = urlParams.encode(queryParams);
    return "".concat(baseUrl, "?").concat(queryString).concat(consentPolicyParams ? "&".concat(consentPolicyParams) : '');
}
export function getMediaImageStudioProdUrl() {
    return isEditorxDomain()
        ? MediaImageStudioURL.ProdEditorX
        : MediaImageStudioURL.Prod;
}
//# sourceMappingURL=url.js.map